import { saveManagedDocumentDraftBody } from './generated/api';
import type { z } from 'zod/v4';
export type DocumentStyles = NonNullable<z.infer<typeof saveManagedDocumentDraftBody>['content']['styles']>;
export type DocumentStyle = DocumentStyles['definitions'][number];
export const documentStyleIds = ['normal', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5', 'heading-6'] as const;
export function defaultDocumentStyles(): DocumentStyles {
  return { schemaVersion: 1, definitions: documentStyleIds.map((id, index) => ({
    id, name: index ? 'Heading ' + index : 'Normal', fontFamily: 'Arial', fontSize: [11,24,20,16,14,12,11][index]!,
    color: '#000000', bold: index > 0, italic: false, underline: false, alignment: 'left', spaceBefore: index ? 12 : 0, spaceAfter: 6, lineHeight: 1.15
  })) };
}
export function validateDocumentStyles(value: unknown): DocumentStyles {
  const styles = saveManagedDocumentDraftBody.shape.content.shape.styles.unwrap().parse(value);
  const ids = new Set(styles.definitions.map(s => s.id)), names = new Set(styles.definitions.map(s => s.name.trim().toLocaleLowerCase('en-US')));
  if (ids.size !== styles.definitions.length || names.size !== styles.definitions.length || styles.definitions.some(s => !s.name.trim()) || documentStyleIds.some(id => !ids.has(id))) throw new Error('Include every built-in style once with unique names and identities.');
  return styles;
}
export function documentStyleForNode(styles: DocumentStyles | undefined, node: {type: string;attrs?: Record<string, unknown>}): DocumentStyle | undefined {
  if (!styles || !['paragraph','heading'].includes(node.type) || node.attrs?.sectionTitleId) return undefined;
  const id = node.attrs?.styleId ?? (node.type === 'heading' ? 'heading-' + String(node.attrs?.level ?? 2) : 'normal');
  return styles.definitions.find(s => s.id === id);
}
